<template>
	<section class="small-12 publicHeader flex vertical-align animated fadeIn" @mouseover="isMegaMenuOpen = true" @mouseleave="isMegaMenuOpen = false">
		<div class="small-12 columns wrap flex vertical-align">
			<div class="small-12 large-2 columns siteLogo flex vertical-align">
				<router-link class="logoLink" :to="{ name: 'SiteIndex' }">
					<picture class="small-12 flex vertical-align">
						<img width="75" class="animated fadeIn flex" :src="logo" alt="Nestd Logo">
					</picture>
				</router-link>
			</div>
			<div class="small-12 large-8 flex vertical-align">
				<ul class="small-12 flex vertical-align justify-center">
					<li class="small-12 large-3 flex columns">
						<a class="flex vertical-align columns">
							<span class="auto flex float-left">Operating</span>
						</a>
					</li>
					<li class="small-12 large-3 flex columns">
						<a class="flex vertical-align columns">
							<span class="auto flex float-left">Growing</span>
						</a>
					</li>
					<li class="small-12 large-3 flex columns">
						<router-link :to="{ name: 'BlogIndex' }" class="flex vertical-align columns router-link-exact-active" v-if="$route.name == 'BlogCategory'">
							<span class="auto flex float-left">Blog</span>
						</router-link>
						<router-link :to="{ name: 'BlogIndex' }" class="flex vertical-align columns" v-else>
							<span class="auto flex float-left">Blog</span>
						</router-link>
					</li>
					<li class="small-12 large-3 flex columns">
						<router-link :to="{ name: 'Help' }" class="flex vertical-align columns router-link-exact-active" v-if="$route.name == 'HelpCategory' || $route.name == 'HelpArticle'">
							<span class="auto flex float-left">Help</span>
						</router-link>
						<router-link :to="{ name: 'Help' }" class="flex vertical-align columns" v-else>
							<span class="auto flex float-left">Help</span>
						</router-link>
					</li>
				</ul>
			</div>
			<div class="small-12 large-2 columns sisuNav flex vertical-align">
				<ul class="small-12 flex vertical-align justify-right">
					<li class="auto" v-if="!authd">
						<router-link :to="{ name: 'SignIn' }" class="signIn noFillButton">
							Sign In
						</router-link>
					</li>
					<li class="auto" v-if="!authd">
						<router-link :to="{ name: 'SignUp' }" class="signUp borderRadius4 flex vertical-align">
							Sign Up
						</router-link>
					</li>
					<li class="auto" v-if="authd">
						<router-link :to="{ name: 'Dashboard' }" class="signUp borderRadius4 flex vertical-align">
							Dashboard
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<mega-menu :menuOpen="isMegaMenuOpen" v-on:update:isMegaMenuOpen="isMegaMenuOpen = $event"/>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth } from '@/firebase/firebase-config'

	// Import the components
	import MegaMenu from '@/components/framework/header/menus/MegaMenu.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'HeaderPublic',

		/*
		**  Register the components
		*/

		components: {

		    MegaMenu

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			logo: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-full.png?alt=media&token=0885b8ed-a0e4-4498-8a19-38f20f3b1b55',
			futureItem: false,
			isMegaMenuOpen: false,
			authd: false

		}),

		/*
		**  Do this first
		*/

		created() {

			/*
			**  Check is user is logged in
			**  @prop_location: @here
			*/

			if (firebaseAuth.currentUser) this.authd = true;

		},

		/*
		**  Set up the methods
		*/

		methods: {

			openMegaMenu: function() {

				// Set the prop
				this.isMegaMenuOpen = true;

			},

			closeMegaMenu: function() {

				this.isMegaMenuOpen = false

			}

		}

	}

</script>